// src/api/cartApi.js
import axios from "axios";
import { baseURL, diviceToken } from "../../helper/helper";

const API = axios.create({
  baseURL: `${baseURL}/api`,
  // withCredentials: true,
});

export const fetchCartAPI = () => API.get(`/version3/cart${diviceToken ? `?device_token=${diviceToken}` : ""}`);
export const addToCartAPI = (data) => API.post("/cart", data);
export const updateCartAPI = (data) => API.post(`/cart/update-qty`, data);
export const removeFromCartAPI = (data) => API.post(`/cart/remove`, data);
